function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFoodBentoFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 5V3h20v2H6zm0 14h20V3l.204.01a2 2 0 011.785 1.786L28 5v14a2 2 0 01-2 2H6a2 2 0 01-2-2V5l.01-.204A2 2 0 015.797 3.01L6 3v16z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 21h-2V3h2v18z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 11v2H5v-2h8zM4 25v-1l24-1v2H4zM4 26v1l24 1v-2H4zM9 17a1 1 0 112 0 1 1 0 01-2 0zM7 15a1 1 0 112 0 1 1 0 01-2 0zM10 10H8V6h2v4z",
    fill: props.color
  }));
}

export default SvgIconFoodBentoFilled;